/**
 * MobileModeInfoTip — Wraps the Mobile Mode button: hovering or focusing it shows what the mode
 * does, and clicking it closes the note (InfoPopover describe mode).
 */

import InfoPopover from '../../../../components/v2/InfoPopover.jsx';

const MOBILE_TOOLTIP = [
    'Mobile Mode simulates the alert experience of our mobile application.',
    'The ability to accept alerts is still based on System Settings.',
];

const MobileModeInfoTip = ({ children }) => (
    <InfoPopover mode="describe" marker="none" heading="About Mobile Mode" body={MOBILE_TOOLTIP.join(' ')}>
        {children}
    </InfoPopover>
);

export default MobileModeInfoTip;
